import React, { Component } from 'react';
import Signup from '../components/signup'


class App extends Component{
    constructor(props) {
        super(props);
        this.state = {
            personType: 0,
            documentNumber: '',
            documentType: '',
            email: '',
            re: /\S+@\S+\.\S+/, // regular expression for validate input type email
            inputValidCellPhone: true,
            inputValid: true,
            placeholderNit: '0/9'
        };
    }
    //Person type selection
    selectPersonType = (evt) =>{
        let {param} = evt.target.dataset;

        if(param === 'natural'){
            this.setState({
                personType: 2,
                documentType: ''
            });
        }
        else{
            this.setState({
                personType: 1,
                documentType: 'nit'
            });
        }
        //this.captcha();
        const script = document.createElement("script");
        script.src = "https://www.google.com/recaptcha/api.js";
        script.async = true;
        document.body.appendChild(script);
    }
    //Validate input Number
    inputToNumber(inputText){
        return (((inputText||"").toString().replace(/[^0-9]/g, ""))||"");
    }
    //Validate input text
    inputToText(inputText){
        return (((inputText||"").toString().replace(/[^a-zA-ZáÁéÉíÍóÓúÚñÑüÜ\s]/g, ""))||"");
    }
    //Digit verification
    calculateDv(nit) {
        var arreglo, x, y, z, i, dv1;

        arreglo = new Array(16);
        x = 0;
        y = 0;
        z = nit.length;
        arreglo[1]=3;
        arreglo[2]=7;
        arreglo[3]=13;
        arreglo[4]=17;
        arreglo[5]=19;
        arreglo[6]=23;
        arreglo[7]=29;
        arreglo[8]=37;
        arreglo[9]=41;
        arreglo[10]=43;
        arreglo[11]=47;
        arreglo[12]=53;
        arreglo[13]=59;
        arreglo[14]=67;
        arreglo[15]=71;
        for(i=0;i<z;i++) {
            y=(nit.substr(i,1));
            x+=(y*arreglo[z-i]);
        }
        y=x%11
        if(y>1) {
            dv1=11-y;
        } 
        else {
            dv1=y;
        }
        return dv1;
    }
    //Change input form
    handleChange = (event) =>{
        //validation for input form register
        var value = ''

        if(event.target.type === "select-one"){
            value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        }
        else{
            value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        }
        
        const name = event.target.name;

        if(name === 'documentNumber'){
            value = this.inputToNumber(event.target.value);
        }
        else if(name === 'cellPhone'){
            value = this.inputToNumber(event.target.value);
            
            this.setState({
                inputValidCellPhone: value.length < 10 ? false : true
            });
            
        }
        else if(name === 'firstName' || name === 'lastName'){
            value = this.inputToText(event.target.value);
        }

        if (this.state.personType === 1 && name === "documentNumber") {
            
            this.setState({
                placeholderNit: this.calculatePlaceHolder(value),
                inputValid: value.length < 8 ? false : true
            });
        }
        
        this.setState({
             [name]: value
        });
        //set value of input
        event.target.value = value;
    }
    // Calculate value of placeholder
    calculatePlaceHolder(value) {
        var actualLength = value.length;
        var placeholderValue = this.state.placeholderNit;
        var splitValue = placeholderValue.split("/");

        splitValue[0] = actualLength

        return splitValue.toString().replace(",", "/")

    }

  render(){
    return (
      <Signup personType={this.state.personType} re={this.state.re} documentNumber={this.state.documentNumber} email={this.state.email} selectPersonType={this.selectPersonType} handleChange={this.handleChange} documentType={this.state.documentType} calculateDv={this.calculateDv} inputValidCellPhone={this.state.inputValidCellPhone} inputValid={this.state.inputValid} placeholderNit={this.state.placeholderNit}></Signup>
    );
  }
}

export default App;